import app from "../_app";

const gallery = document.querySelector('.js-product-gallery');

if(gallery) {

    const galleryHandler = (index) => {
        if(gallery.hasAttribute('data-open')){
            app.unlockBody();
            gallery.removeAttribute('data-open');

        }else {
            app.lockBody();
            gallery.setAttribute('data-open', '');
            gallery.querySelectorAll('.col-12')[index].scrollIntoView();

        }
    };

    const triggers = [...document.querySelectorAll('.js-gallery-trigger')];
    const videoTriggers = [...document.querySelectorAll('.js-gallery-video-trigger')];

    triggers.map(trigger => trigger.addEventListener('click', () => {
        galleryHandler(trigger.getAttribute('data-number'));
    }));
    videoTriggers.map(videoTrigger => videoTrigger.addEventListener('click', () => {
        galleryHandler(videoTrigger.getAttribute('data-number'));
    }));
}